<template>
  <div class="login-bg">
    <button
      type="button"
      class="auth-home-btn"
      aria-label="Home"
      @click="$router.push('/home')"
    >
      <i class="fas fa-home" aria-hidden="true"></i>
    </button>
    <div
      class="login-cont container"
      style="height: 80vh;"
    >
      <div class="d-flex justify-content-center h-100">
        <div class="col-12 px-0 d-flex flex-column my-auto">
          <button
            type="button"
            class="auth-logo"
            @click="$router.push('/home')"
          >
            <img
              src="/assets/12k-new.avif"
              alt="12K"
              class="auth-logo__img"
            >
          </button>
          <!-- <div class="card border-0 mb-0 auth-card bg-transparent"> -->
          <div
            class="card-body px-2 d-flex mx-0 col-12 mx-auto"
            style="background: rgba(255, 255, 255, 0.98);border-radius: 16px;box-shadow: 0 8px 32px rgba(26, 46, 31, 0.12);backdrop-filter: blur(12px);-webkit-backdrop-filter: blur(12px);border: 1px solid rgba(13, 59, 26, 0.25);"
          >
            <div class="my-auto col-12">
              <div class="text-center mb-4">
                <div
                  class="error text-center py-2"
                  v-if="error"
                >
                  <span class="mx-auto">
                    {{ $t('auth.fail_message') }}
                  </span>

                </div>
              </div>
              <form role="form">
                <small class="text-dark">{{ errors.phone }}</small>
                <div class="form-group mb-3">
                  <label style="color: #0D3B1A; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.phone') }}</label>
                  <!-- <div
                      class="input-group input-group-merge input-group-alternative bg-transparent"
                    > -->
                  <input
                    class="form-control pl-2 px-4"
                    style="background: #F5F7F5 !important; color: #1A2E1F; box-shadow: none; border-radius: 8px; border: 1px solid rgba(13, 59, 26, 0.35); font-size: 1.2rem;"
                    type="text"
                    v-model="name"
                    @keyup.enter="focusOnPasswordInputBox"
                  />
                  <!-- </div> -->
                </div>
                <small class="text-dark">{{ errors.password }}</small>
                <div class="form-group pt-3">
                  <label style="color: #0D3B1A; font-weight: 550; letter-spacing: 0.5px;">{{ $t('auth.password')
                  }}</label>
                  <!-- <div
                      class="input-group input-group-merge input-group-alternative"
                    > -->
                  <div class="input-group">
                    <input
                      class="form-control pl-2 px-4"
                      style="background: #F5F7F5 !important; color: #1A2E1F; box-shadow: none; border-radius: 8px; border: 1px solid rgba(13, 59, 26, 0.35); font-size: 1.2rem;"
                      type="password"
                      ref="password"
                      v-model="password"
                      @keyup.enter="loginWithPhone"
                    />
                    <i
                      class="far fa-eye showable-password"
                      style="color: #0D3B1A;"
                      v-if="isShow"
                      @click="showablePassword()"
                    ></i>
                    <i
                      v-if="!isShow"
                      class="fas fa-eye-slash showable-password"
                      style="color: #0D3B1A;"
                      @click="showablePassword()"
                    ></i>
                  </div>
                  <!-- </div> -->
                </div>
                <div class="text-center mt-3">
                  <button
                    type="button"
                    class="btn my-4 auth-action-btn auth-action-btn--primary"
                    @click="loginWithPhone()"
                  >
                    <div v-if="!isSignin">
                      {{ $t('auth.login') }}
                    </div>

                    <Loading
                      color="#ffffff"
                      v-if="isSignin"
                      size="24"
                      class="px-4 py-0"
                    />
                  </button>
                </div>
                <div class="col-12 d-flex my-1">
                  <div
                    class="col-5 p-0 my-auto"
                    style="border-top: 1px solid rgba(13, 59, 26, 0.45); height: 0;"
                  ></div>
                  <div
                    class="my-auto px-3"
                    style="color: #0D3B1A;"
                  >OR</div>
                  <div
                    class="col-5 p-0 my-auto"
                    style="border-top: 1px solid rgba(13, 59, 26, 0.45); height: 0;"
                  ></div>
                </div>
                <div class="auth-secondary-row mb-3">
                  <button
                    type="button"
                    class="btn my-0 auth-action-btn auth-action-btn--secondary"
                    @click="$router.push('/auth/register')"
                  >
                    {{ $t('auth.sign_up') }}
                  </button>
                </div>
                <!-- <div class="d-flex justify-content-center">
                      <span style="color: #D32F2F; text-decoration: underline;" @click="$router.push('/auth/not-auth-verify')">Forgot Password?</span>
                    </div> -->
              </form>

              <div class="auth-contact-wrap">
                <p class="auth-contact__hint">
                  {{ $store.state.language === 'en' ? 'Need help?' : 'အကူအညီလိုပါသလား' }}
                </p>
                <div class="row auth-contact-row mx-0">
                  <div class="col-6 auth-contact-col">
                    <a
                      class="auth-contact auth-contact--tile"
                      :href="loginViberHref"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span class="auth-contact__icon auth-contact__icon--viber">
                        <i class="fab fa-viber"></i>
                      </span>
                      <span class="auth-contact__title">Viber</span>
                    </a>
                  </div>
                  <div class="col-6 auth-contact-col">
                    <a
                      class="auth-contact auth-contact--tile auth-contact--telegram"
                      :href="telegramLink(loginTelegram)"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span class="auth-contact__icon auth-contact__icon--telegram">
                        <i class="fab fa-telegram-plane"></i>
                      </span>
                      <span class="auth-contact__title">{{ loginTelegramLabel }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
          <div class="row mt-3">
            <div class="col-4">
              <div
                class="modal fade"
                id="forgetPassword"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-form"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal- modal-dialog-centered"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="modal-body p-5">
                      <b>
                        Please direct contact to customer service -
                        <span class="text-dark">09756477723</span>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from 'vant';
import { mapActions, mapMutations } from 'vuex';
import { viberLink, telegramLink } from '@/utils/contactLinks';

export default {
  components: { Loading },
  data() {
    return {
      name: null,
      password: null,
      error: false,
      errors: {},
      isSignin: false,
      isShow: false,
      defaultTelegram: 'https://t.me/gameautosite_bot',
      defaultViber: 'https://msng.link/o?959451907249=vi',
    }; 
  },
  computed: {
    loginTelegram() {
      return this.$store.state.contactTelegram || this.defaultTelegram;
    },
    loginViberHref() {
      if (this.$store.state.contactInfo) {
        return viberLink(this.$store.state.contactInfo);
      }
      return this.defaultViber;
    },
    loginTelegramLabel() {
      const value = this.loginTelegram;
      if (String(value).startsWith('@')) {
        return value;
      }
      if (String(value).includes('t.me/')) {
        const handle = String(value).split('t.me/').pop().split(/[?#]/)[0];
        return handle ? `@${handle}` : 'Telegram';
      }
      return `@${value}`;
    },
  },
  methods: {
    ...mapActions(['fetchUser']),
    ...mapMutations(['setContactInfo', 'setContactTelegram']),
    telegramLink,
    showablePassword() {
      if (this.isShow) {
        this.$refs.password.type = 'password';
      } else {
        this.$refs.password.type = 'text';
      }
      this.isShow = !this.isShow;
    },
    focusOnPasswordInputBox() {
      this.$refs.password.focus();
    },
    /**
     * login with phone
     */
    async loginWithPhone() {
      this.isSignin = true;
      this.errors = {};
      if (!this.name) {
        this.errors.name = this.$t('auth.require_phone');
        this.isSignin = false;
        return false;
      }
      if (!this.password) {
        this.errors.password = this.$t('auth.require_password');
        this.isSignin = false;
        return false;
      }
      try {
        // if (this.name === 'testuser') {
        //   window.open('https://about.myanmarsoccer.xyz', '_self');
        // } else {
        const res = await this.axios.post(
          '/auth/login',
          {
            phone: this.name,
            password: this.password,
            roles: 'normal',
            fcm: localStorage.getItem('fcm'),
          },
        );
        localStorage.setItem('username', this.name);
        localStorage.setItem('password', this.password);
        localStorage.setItem('token', res.data.token);

        const currentTime = new Date();
        localStorage.setItem(
          'tokenExpire',
          new Date(currentTime.getTime() + 60 * 60 * 1000)
        );
        await this.fetchUser();
        this.$router.push('/home');
        // this.$router.go();
        // ..
        Toast.success(
          this.$store.state.language === 'en'
            ? 'Success!'
            : 'Success!'
        );
        // }
      } catch (err) {
        this.error = true;
      }
      this.isSignin = false;
      return true;
    },
    async fetchWebsiteContact() {
      try {
        const res = await this.axios.get('/website-infos');
        const info = res.data.data[0];
        if (!info) return;
        this.setContactInfo(info.contact_info);
        this.setContactTelegram(
          info.telegram_info
          || info.contact_telegram
          || info.telegram
          || info.telegram_link
          || null
        );
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    this.fetchWebsiteContact();
    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === 'normal')
      this.$router.push('/home');
    const userName = localStorage.getItem('username');
    const password = localStorage.getItem('password');
    if (userName && password) {
      this.name = userName;
      this.password = password;
    }
  },
};
</script>

<style scoped>
.login-bg {
  position: relative;
  min-height: 100vh;
  width: 100%;
  background: #0D3B1A;
  background-color: #0D3B1A;
  display: flex;
  justify-content: center;
  align-items: center;
}

.auth-home-btn {
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.6rem;
  height: 2.6rem;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: #E8B923;
  color: #0D3B1A;
  font-size: 1.15rem;
  cursor: pointer;
}

.auth-home-btn:hover,
.auth-home-btn:focus {
  filter: brightness(1.06);
  outline: none;
}

.login-cont {
  margin-top: -6rem !important;
}

.auth-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0 auto 1.25rem;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

.auth-logo__img {
  display: block;
  height: 9.5rem;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}

.showable-password {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
  z-index: 1000;
}

.new-account-text {
  cursor: pointer;
}

.error {
  margin-bottom: 13px;
  display: flex;
  align-items: center;
  color: #B71C1C;
  border: 1px solid rgba(211, 47, 47, 0.45);
  border-radius: 8px;
  padding: 0px 15px;
  background: #FFEBEE;
  font-weight: 700;
}

.auth-card {
  background: #eeecec;
  /* color: black */
}

.auth-action-btn {
  min-height: 36px !important;
  width: min(100%, 11rem);
  margin-left: auto;
  margin-right: auto;
  border-radius: 18px !important;
  border: none !important;
  outline: none !important;
  font-size: 0.9rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.02em;
  text-shadow: none;
  box-shadow: none !important;
}

.auth-action-btn--primary,
.btn.auth-action-btn--primary {
  background: #0D3B1A !important;
  color: #FFFFFF !important;
}

.auth-action-btn--primary *,
.btn.auth-action-btn--primary * {
  color: #FFFFFF !important;
}

.auth-action-btn--secondary,
.btn.auth-action-btn--secondary {
  width: min(100%, 13rem);
  background: #E8B923 !important;
  color: #0D3B1A !important;
}

.auth-action-btn--secondary *,
.btn.auth-action-btn--secondary * {
  color: #0D3B1A !important;
}

.auth-secondary-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
}

.auth-secondary-row .auth-action-btn--secondary {
  margin: 0 !important;
  width: auto;
  min-width: 8.5rem;
}

.auth-action-btn:hover,
.auth-action-btn:focus {
  filter: brightness(1.08);
  transform: translateY(-1px);
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.auth-action-btn:active {
  transform: translateY(1px);
}

.auth-contact-wrap {
  margin-top: 1.25rem;
  padding-top: 0.25rem;
}

.auth-contact__hint {
  margin: 0 0 0.65rem;
  text-align: center;
  color: #082612;
  font-size: 0.9rem;
  font-weight: 800;
}

.auth-contact-row {
  width: 100%;
}

.auth-contact-col {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.auth-contact {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.7rem 0.85rem;
  border-radius: 12px;
  border: 1px solid rgba(13, 59, 26, 0.35);
  background: #F5F7F5;
  text-decoration: none;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.auth-contact--tile {
  flex-direction: column;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
  min-height: 4.5rem;
  padding: 0.65rem 0.35rem;
  text-align: center;
}

.auth-contact:active {
  background: #E5EBE6;
  border-color: rgba(13, 59, 26, 0.55);
  text-decoration: none;
}

.auth-contact__title {
  color: #082612;
  font-size: 0.95rem;
  font-weight: 800;
  line-height: 1.25;
  word-break: break-word;
}

.auth-contact__icon {
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 1.25rem;
}

.auth-contact__icon--viber {
  background: #7360f2;
  color: #ffffff;
}

.auth-contact__icon--telegram {
  background: #229ed9;
  color: #ffffff;
}
</style>
